/**
 * @type object<{threshold: float}>
 */
export const IO_OPTIONS = {
  threshold: 1
}

export const DEFAULT_DATA_PARAM = 'data-display-sticky-banners'
export const bannerKlass = 'sticky-banner-wrapper'

export const LOGIC_CONFIG = Object.freeze({
  category: {
    next_child_element: 'data-card-lender-row',
    data_name: 'data-beam-name',
    data_issuer: 'data-issuer-name',
    data_category: 'data-category',
    button: 'data-apply-button',
    data_button_link: 'data-link',
    card_art: 'data-card-art',
    data_terms: 'data-sticky-banner-terms',
    rates: 'data-sticky-banner-rates',
    io_config: {
      when_intersecting: true,
      options: {
        threshold: 0.7
      }
    },
    tagular: {
      viewed: {
        variant: 'BUTTON',
        brand: {
          selector: '[data-card-lender-row]',
          attribute: 'data-issuer-name|data-beam-issuer-name'
        },
        category: {
          selector: '[data-card-lender-row]',
          attribute: 'data-category'
        },
        location: 'STICKY',
        name: {
          selector: '[data-card-lender-row]',
          attribute: 'data-beam-name'
        },
        position: 1,
        productId: {
          selector: '[data-card-lender-row]',
          attribute: 'data-id|data-beam-product-id'
        },
        outboundUrl: {
          selector: '[data-apply-button]',
          attribute: 'data-link'
        }
      },
      clicked: {
        correlationId: Math.round(Math.random() * 1e15).toString(),
        actionOutcome: 'APPLY',
        variant: 'BUTTON',
        brand: {
          selector: '[data-card-lender-row]',
          attribute: 'data-issuer-name|data-beam-issuer-name'
        },
        category: {
          selector: '[data-card-lender-row]',
          attribute: 'data-category'
        },
        location: 'STICKY',
        name: {
          selector: '[data-card-lender-row]',
          attribute: 'data-beam-name'
        },
        position: 1,
        productId: {
          selector: '[data-card-lender-row]',
          attribute: 'data-id|data-beam-product-id'
        },
        outboundUrl: {
          selector: '[data-apply-button]',
          attribute: 'data-link'
        }
      }
    }
  },
  reviews: {
    element: 'data-observe',
    data_name: 'data-name',
    data_issuer: 'data-issuer-name',
    data_category: 'data-category',
    button: 'data-apply-button',
    data_button_link: 'data-link',
    card_art: 'data-card-art',
    data_terms: 'data-sticky-banner-terms',
    rates: 'data-sticky-banner-rates',
    io_config: {
      when_intersecting: false,
      options: {
        threshold: 1
      }
    },
    tagular: {
      viewed: {
        variant: 'BUTTON',
        brand: {
          selector: '[data-card-lender-row]',
          attribute: 'data-card-vendor'
        },
        category: 'CARD REVIEW',
        location: 'STICKY',
        name: {
          selector: '[data-card-lender-row]',
          attribute: 'data-name'
        },
        position: 1,
        productId: {
          selector: '[data-card-lender-row]',
          attribute: 'data-id'
        },
        outboundUrl: {
          selector: '[data-apply-button]',
          attribute: 'data-link'
        }
      },
      clicked: {
        correlationId: Math.round(Math.random() * 1e15).toString(),
        variant: 'BUTTON',
        brand: {
          selector: '[data-card-lender-row]',
          attribute: 'data-card-vendor'
        },
        category: 'CARD REVIEW',
        location: 'STICKY',
        name: {
          selector: '[data-card-lender-row]',
          attribute: 'data-name'
        },
        position: 1,
        productId: {
          selector: '[data-card-lender-row]',
          attribute: 'data-id'
        },
        outboundUrl: {
          selector: '[data-apply-button]',
          attribute: 'data-link'
        }
      }
    }
  },
  reviews_mobile: {
    element: 'data-observe',
    data_name: 'data-name',
    data_issuer: 'data-issuer-name',
    data_category: 'data-category',
    button: 'data-apply-button',
    data_button_link: 'data-link',
    card_art: 'data-card-art',
    data_terms: 'data-sticky-banner-terms',
    rates: 'data-sticky-banner-rates',
    io_config: {
      when_intersecting: true,
      options: {
        threshold: 0.1
      }
    },
    tagular: {
      viewed: {
        variant: 'BUTTON',
        brand: {
          selector: '[data-card-lender-row]',
          attribute: 'data-card-vendor'
        },
        category: 'CARD REVIEW',
        location: 'STICKY',
        name: {
          selector: '[data-card-lender-row]',
          attribute: 'data-name'
        },
        position: 1,
        productId: {
          selector: '[data-card-lender-row]',
          attribute: 'data-id'
        }
      },
      clicked: {
        correlationId: Math.round(Math.random() * 1e15).toString(),
        variant: 'BUTTON',
        actionOutcome: 'APPLY',
        brand: {
          selector: '[data-card-lender-row]',
          attribute: 'data-card-vendor'
        },
        category: 'CARD REVIEW',
        location: 'STICKY',
        name: {
          selector: '[data-card-lender-row]',
          attribute: 'data-name'
        },
        position: 1,
        productId: {
          selector: '[data-card-lender-row]',
          attribute: 'data-id'
        }
      }
    }
  }
})

export const CONFIG_TEMPLATE_VARIABLES_TO_SKIP = [
  'element',
  'io_config',
  'tagular'
]

export const TEMPLATE = `
    <dialog class="${bannerKlass}">
      <div class="inner-container">
        <div class="image-wrapper">
          <img src="%card_art%" alt="card art image" onerror="this.style.display = 'none'">
        </div>
        <div class="middle-section">
          <div class="category font-bold">FEATURED <span>%category%</span> CARD</div>
          <div class="card-name font-bold">%name%</div>
          <div class="terms-rates font-book">%terms_rates%</div>
        </div>
        <div class="right-section">
          <a href="%button_link%" class="button --primary" target="_blank" data-sticky-banner-apply-button>
          Apply now <span class="icon --icon-xs +mg-bottom-xs">
              <svg class="icon__glyph" xmlns="http://www.w3.org/2000/svg" width="17" height="23" viewBox="0 0 17 23">
                <path fill-rule="evenodd" d="M13.4333333,1.5 C15.8633862,1.5 17.8333333,3.4699471 17.8333333,5.9 L17.8333333,8.83333333 L19.4,8.83333333 C20.0075132,8.83333333 20.5,9.32582011 20.5,9.93333333 L20.5,19.1 C20.5,21.5300529 18.5300529,23.5 16.1,23.5 L8.9,23.5 C6.4699471,23.5 4.5,21.5300529 4.5,19.1 L4.5,9.93333333 C4.5,9.32582011 4.99248678,8.83333333 5.6,8.83333333 L7.16666667,8.83333333 L7.16666667,5.9 C7.16666667,3.4699471 9.13661377,1.5 11.5666667,1.5 L13.4333333,1.5 Z M12.5288136,13.809437 C11.6149825,13.809437 11.1847548,14.6415245 11.1847548,15.1250244 C11.1847548,15.4473577 11.3432404,15.7896813 11.6602116,16.1519953 L11.0503539,18.4945536 L14.0072733,18.4945536 L13.3012434,16.2940019 C13.636962,15.9751573 13.8048214,15.5854982 13.8048214,15.1250244 C13.8048214,14.4343139 13.4426447,13.809437 12.5288136,13.809437 Z M13.4333333,2.16666667 L11.5666667,2.16666667 C9.5048036,2.16666667 7.83333333,3.83813693 7.83333333,5.9 L7.83333333,8.83333333 L17.1666667,8.83333333 L17.1666667,5.9 C17.1666667,3.83813693 15.4951964,2.16666667 13.4333333,2.16666667 Z" transform="translate(-4 -1)"></path>
              </svg>
            </span>
          </a>
        <div class="button-sub-text +text-center font-book">On <span>%issuer%'s</span> secure website</div>
        </div>
         <button class="banner-close-button modal__close icon --icon-xs" aria-label="close banner">
            <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            v-bind:aria-hidden="show ? 'false' : 'true'"
            class="icon__glyph"
            viewBox="0 0 10 10"
            >
                <path
                fill="#151515"
                fill-rule="evenodd"
                d="M6.257 4.6667l3.1428 3.1427-1.2571 1.257L5 5.9237 1.8573 9.0664l-1.257-1.257 3.1426-3.1427L.6002 1.524 1.8573.2669 5 3.4096 8.1427.2669l1.257 1.257-3.1426 3.1428z"
                />
            </svg>
          </button>
      </div>
    </dialog> 
  `

/**
 * @description Get the main wrapping element
 * @returns HTMLElement
 */
export const WRAPPER_ELEMENT = document.querySelector(`[${DEFAULT_DATA_PARAM}]`)

/**
 * @description Get the name of the current config
 * @type String
 * @returns string
 */
export const BANNER_ELEMENT_CONFIG_NAME = WRAPPER_ELEMENT
  ? WRAPPER_ELEMENT.getAttribute(DEFAULT_DATA_PARAM)
      .split('-')
      .pop()
  : null

/**
 * @description Get the config for what page we're on
 * @returns Object
 */
export const BANNER_ELEMENT_CONFIG = LOGIC_CONFIG[BANNER_ELEMENT_CONFIG_NAME]

/**
 * @description I'm sorry. This turned into a clusterf***. But it returns the fully formatted config object with all the data you need
 * @param obj {Object}
 * @returns Object
 */
export const BANNER_SRC = (obj = BANNER_ELEMENT_CONFIG) => {
  let formattedObj = {}

  if (!document_contains_attrs()) return

  // Build the config object with the elements/values needed to build banner
  Object.keys(obj).forEach(key => {
    if (/^(next_child)_/.test(key)) {
      // The prefix 'next_child_*' is just telling it to grab the next element of the value of the key

      formattedObj[
        key.split(/^(next_child_)/).pop()
      ] = document.querySelectorAll(`[${obj[key]}]`)[1]
    } else if (/^(data_([a-z]+))$/i.test(key)) {
      // The prefix 'data_*'is telling it that the value we need is a data attribute and not an HTMLElement

      let elementName = obj['next_child_element'] ?? obj['element']
      let elm = document.querySelector(`[${elementName}]`)

      if (elm) {
        let value = elm.getAttribute(obj[key])

        // only show terms_rates for issuers that have a terms link Amex, Discover, Wells Fargo and build a link
        if (key === 'data_terms' && value) {
          formattedObj[
            key.split(/^(data_)/).pop()
          ] = `<a href="${value}" target="_blank" class="text-link --standalone +type-body-one +text-crop-none --plain +text-size-sm">See Rates &amp; Fees</a>`
        } else {
          formattedObj[key.split(/^(data_)/).pop()] = value
        }
      }
    } else if (/^(data_.+_.+)$/i.test(key)) {
      // The 'data_*_*' is saying that I need the data attribute from a child element where the middle param must match
      // a key in the root config, and the last param is the key of the final output. So 'data_button_link' is saying
      // that I need the data_link property off the `button: 'data-apply-button'` element and the output will be `link: '<data attribute value>'`

      let match = key.match(/^data_(\w+)_.+$/)[1]
      let objParent = obj[match]
      let elm = document.querySelector(`[${objParent}]`)

      if (elm) {
        formattedObj[key.split(/^(data_)/).pop()] = elm.getAttribute(obj[key])
      }
    } else if (/^(card_art)$/i.test(key)) {
      // Just get the 'src' off the card image

      let elm = document.querySelector(`[${obj[key]}]`)

      if (elm) {
        formattedObj[key] =
          elm.getAttribute('src') ?? elm.getAttribute('data-src')
      }
    } else if (key === 'rates') {
      let elementName = obj['next_child_element'] ?? obj['element']

      if (elementName) {
        formattedObj[key] = document
          .querySelector(`[${elementName}]`)
          .querySelector(`[${obj[key]}]`)
      }
    } else {
      // Just get the HTMLElement

      if (!['io_config', 'tagular'].includes(key)) {
        formattedObj[key] = document.querySelector(`[${obj[key]}]`)
      }
    }
  })

  Object.keys(formattedObj).forEach(k => {
    // going with just this for now for consistency on banners
    formattedObj['terms_rates'] = formattedObj['terms']

    // Handle null
    if (
      ['[object Null]', '[object Undefined]'].includes(
        toString.call(formattedObj[k])
      )
    ) {
      formattedObj[k] = ''
    }
  })

  if (toString.apply(obj.tagular) === '[object Object]') {
    formattedObj['tagular'] = {}
    let tagular = obj.tagular

    // eslint-disable-next-line
    function isObject(elm) {
      return toString.call(elm) === '[object Object]'
    }

    Object.keys(obj.tagular).forEach(firstK => {
      if (isObject(tagular[firstK])) {
        formattedObj['tagular'][firstK] = {}

        Object.keys(tagular[firstK]).forEach(secondK => {
          if (isObject(tagular[firstK][secondK])) {
            let selector = tagular[firstK][secondK]['selector']
            let attr = tagular[firstK][secondK]['attribute'].split('|')

            if (document.querySelector(selector)) {
              formattedObj['tagular'][firstK][secondK] = document
                .querySelector(selector)
                .getAttribute(attr[0])
                ? document.querySelector(selector).getAttribute(attr[0])
                : document.querySelector(selector).getAttribute(attr[1])
            }
          } else {
            formattedObj['tagular'][firstK][secondK] = tagular[firstK][secondK]
          }
        })
      } else {
        formattedObj['tagular'][firstK] = tagular[firstK]
      }
    })
  }

  return formattedObj
}

export const RESOLVED_ELEMENTS = BANNER_SRC()

/**
 * @description Checks the page for elements that match ACCEPTABLE_DATA_ATTRS
 * @returns boolean
 */
export function document_contains_attrs() {
  return document.body.contains(
    document.querySelector(`[${DEFAULT_DATA_PARAM}]`)
  )
}

export function BUILD_ASSET_URI(path) {
  const asset_url = window.assetUrl || ''
  return `${asset_url}${~window.assetUrl.search(/\/$/) ? '' : '/'}${path}`
}

/**
 * @description To prevent race condition, it keeps trying `maxTries` with a `delay` multiplied by 2, and tries `tryLogicCb` for
 *              a return of true to then call passed callback. If maxTries runs out, null is returned.
 * @param tryLogicCb {function<tryLogicCb>}
 * @param maxTries {number}
 * @param delay {number}
 * @param callback {function<callback>}
 * @returns Null|callback
 */
export function exponentialBackoff(tryLogicCb, maxTries, delay, callback) {
  const result = tryLogicCb()

  if (result) {
    callback.call(this)
  } else {
    if (maxTries > 0) {
      setTimeout(() => {
        exponentialBackoff.call(
          this,
          tryLogicCb,
          --maxTries,
          delay * 2,
          callback
        )
      }, delay)
    }
  }
}

/**
 * @returns boolean
 */
export function isStickyBannersReady() {
  return window.stickyBannersReady && document.readyState === 'complete'
}
